import React, {Component} from 'react';
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {Button, InputGroupAddon, Tooltip} from "reactstrap";
import classnames from "classnames";
import InputNumber from "components/InputNumber";

class AnswersCount extends Component {

  constructor(props) {
    super(props);
    this.state = {
      question: {
        answersCount: props.question.answersCount,
      },
      tooltip: false,
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  toggleTooltip() {
    this.setState({
      tooltip: !this.state.tooltip
    });
  }

  onChange(value){
    if(!value || value < 0){
      value = 0;
    }

    this.setState({
      question: {
        ...this.state.question,
        answersCount: value
      }
    },
      () => this.props.handleUpdate(this.state.question)
    );
  }

  render() {
    let { question, tooltip } = this.state;

    return (
      <div
        id={"answersCount-" + this.props.question.id}
        className={classnames({
          "min-w-0 float-left mr-1 mb-1": true,
          "w-auto": question.answersCount === 0,
          "w-100 w-lg-auto input-group": question.answersCount > 0
        })}
      >
        <InputGroupAddon addonType="prepend">
          <Button
            className={classnames({
              "btn-icon": true,
              "active": question.answersCount > 0,
            })}
            color="secondary"
            onClick={() => {
              if(question.answersCount === 0){
                this.onChange(1)
              }else{
                this.onChange(0)
              }
            }}
          >
            <i className="fas fa-bars" />
            <Tooltip
              delay={0}
              placement="top"
              isOpen={tooltip}
              target={"answersCount-" + this.props.question.id}
              toggle={() => this.toggleTooltip()}
            >
              <FormattedMessage id="question.settings.answersCount.button.tooltip"/>
            </Tooltip>
          </Button>
        </InputGroupAddon>
        {question.answersCount > 0 && <InputNumber value={question.answersCount} min={1} max={99} onChange={(value) => this.onChange(value)}/>}
      </div>
    )
  }
}

AnswersCount.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    answersCount: PropTypes.number.isRequired
  }).isRequired,
  handleUpdate: PropTypes.func.isRequired,
};

export default AnswersCount;
